import { html, css } from 'lit-element';
import { FormElement } from './form-element-base';
import { HeaderStyles } from '../styles/header-styles';
import '@trumedianetworks/tmn-core-components/src/tmn-radio';
import '@trumedianetworks/tmn-core-components/src/tmn-input';
import '@trumedianetworks/tmn-core-components/src/tmn-checkbox';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-form-group';
import '@trumedianetworks/tmn-core-components/src/tmn-select';
import '@trumedianetworks/tmn-core-components/src/tmn-icon';
import './form-element-radio-group';

import { connect } from '../store/connect';
import { selectors } from '../site/';
import { RUGBY_AUTH_DEFS, RUGBY_CATEGORY_OPTIONS } from './constants';
const { RUGBY_LEAGUE, RUGBY_UNION } = RUGBY_CATEGORY_OPTIONS;
const COMP_LIMIT_TYPE = {
    NONE: 'NONE', // meaning all available
    ALLOW: 'ALLOW',
    DENY: 'DENY',
};

class FormElementRugbyCompetitions extends FormElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            super.styles,
            HeaderStyles.styles,
            css`
                :host {
                    padding: 0 10px;
                    border-radius: 8px;
                    background-color: #f9f9f9;
                    display: flex;
                    flex-direction: column;
                }
                tmn-select {
                    font-size: 14px;
                    min-width: 155px;
                    width: 100%;
                    max-width: unset;
                }
                tmn-radio-group {
                    display: flex;
                    flex-flow: column;
                }
                tmn-radio {
                    display: flex;
                }
                .radio-container {
                    /* color: var(--app-on-primary-color); */
                    /* background: var(--menu-select-color); */
                    /* background: var(--app-primary-color); */
                    display: flex;
                    flex-flow: column;
                    border: 1px solid var(--app-primary-color);
                    border-radius: 8px;
                    padding: 6px;
                    margin-bottom: 8px;
                }
                tmn-button {
                    margin: 8px;
                }
                .data-option-container > div {
                    display: flex;
                }
                .data-option-container > div > tmn-form-group {
                    margin-right: 12px;
                }
                form-element-site {
                    max-width: unset;
                }
            `,
        ];
    }

    static get properties() {
        return {
            value: {
                type: Object,
            },
            authOptions: {
                type: Array,
            },
            availableComps: {
                type: Array,
            },
        };
    }

    firstUpdated() {}

    updated(changedProps) {}

    render() {
        if (this.isViewMode()) {
            return html`${this.renderHeader()}
                <div class="content">${this.renderDisplayView()}</div>`;
        }
        return html`
            ${this.renderHeader()}
            <div class="content">${this.renderEditView()}</div>
        `;
    }

    renderHeader() {
        return html`<div class="data-option-container">
                <h3>Data Options</h3>
                <div>${this.renderDataOptions()}</div>
                <div>${this.renderClassAuth()}</div>
            </div>
            <h3>Competition Options</h3>`;
    }

    renderDataOptions() {
        return RUGBY_AUTH_DEFS.map(
            ({ auth, label }) => html`${this.renderDataOption(auth, label)}`
        );
    }

    renderDataOption(auth, label) {
        const dataAuthorizations = this.getDataAuths();
        const checked = !!dataAuthorizations[auth];
        if (this.isViewMode()) {
            return html`
                <tmn-form-group row>
                    <label>
                        ${checked
                            ? html`<tmn-icon icon="check_circle_outline"></tmn-icon>`
                            : html`<tmn-icon
                                  class="unchecked"
                                  icon="circle"
                                  iconvariant="outlined"></tmn-icon>`}
                    </label>
                    ${label}
                </tmn-form-group>
            `;
        }

        return html`<tmn-checkbox
            label=${label}
            .value=${auth}
            .checked=${checked}
            @tmn-switch-change=${this.handleDataAuthChanged}
            >${label}
        </tmn-checkbox> `;
    }

    getDataAuths() {
        const { value = {} } = this;
        const { dataAuthorizations = {} } = value;
        return dataAuthorizations;
    }

    handleDataAuthChanged(e) {
        this.preventPropagation(e);
        const { path, value = {} } = this;
        const dataAuthorizations = this.getDataAuths();
        const { checked, value: auth } = e.detail;
        const newDataAuthorizations = {
            ...dataAuthorizations,
            [auth]: checked,
        };
        const newValue = {
            ...value,
            dataAuthorizations: newDataAuthorizations,
        };
        this.actions.setStagedEditByPath(path, newValue);
    }

    renderClassAuth() {
        const { path, itemTemplate } = this;
        const classAuthTemplate = itemTemplate?.properties?.classAuth;
        const classAuthPath = path + '.classAuth';
        return html`
            <form-element-site
                .itemTemplate=${classAuthTemplate}
                .path=${classAuthPath}
                .isOverrideMode=${false}></form-element-site>
        `;
    }

    renderDisplayView() {
        const { limitType, whitelistSelections, blacklistSelections } = this.getSelectedValues();
        const allCompsAllowed = limitType === COMP_LIMIT_TYPE.NONE;
        const allowList = whitelistSelections.length
            ? whitelistSelections.map((s) => s.displayKey).join(', ')
            : `<EMPTY>`;
        const denyList = blacklistSelections.length
            ? blacklistSelections.map((s) => s.displayKey).join(', ')
            : `<EMPTY>`;
        return html`<tmn-form-group
                ><label>Allow All Competitions:</label
                ><span>${allCompsAllowed}</span></tmn-form-group
            >
            <tmn-form-group
                ><label>Allowed Competitions:</label><span>${allowList}</span></tmn-form-group
            >
            <tmn-form-group
                ><label>Denied Competitions:</label><span>${denyList}</span></tmn-form-group
            > `;
    }

    renderEditView() {
        const { itemTemplate, value, availableComps = [] } = this;
        const { limitType, whitelistSelections, blacklistSelections } = this.getSelectedValues();
        const isAllSelected = limitType === COMP_LIMIT_TYPE.NONE;
        const isAllowSelected = limitType === COMP_LIMIT_TYPE.ALLOW;
        const isDenySelected = limitType === COMP_LIMIT_TYPE.DENY;
        return html`<tmn-radio-group>
            <div class="radio-container">
                <tmn-radio
                    @click=${this.handleCompOptionChanged}
                    name="limitType"
                    value=${COMP_LIMIT_TYPE.NONE}
                    .checked=${isAllSelected}
                    >Allow All Competitions</tmn-radio
                >
            </div>
            <div class="radio-container">
                <tmn-radio
                    @click=${this.handleCompOptionChanged}
                    name="limitType"
                    value=${COMP_LIMIT_TYPE.ALLOW}
                    .checked=${isAllowSelected}
                    >Allow List</tmn-radio
                >
                ${isAllowSelected
                    ? html`<div class="list-wrapper" @click=${this.preventPropagation}>
                          <tmn-select
                              .multiple=${true}
                              @tmn-selections-changed=${this.handleSelectChanged}
                              .data=${availableComps}
                              .name=${'compWhitelist'}
                              .label=${'Allow Competitions'}
                              .selections=${whitelistSelections}></tmn-select
                          ><tmn-button @click="${this.handleClear}" .name=${'compWhitelist'}>
                              <tmn-icon
                                  color="primary"
                                  icon="clear_all"
                                  iconvariant="outlined"
                                  slot="startIcon"></tmn-icon>
                              Clear Allow List
                          </tmn-button>
                      </div>`
                    : null}
            </div>
            <div class="radio-container">
                <tmn-radio
                    @click=${this.handleCompOptionChanged}
                    name="limitType"
                    value=${COMP_LIMIT_TYPE.DENY}
                    .checked=${isDenySelected}
                    >Deny List</tmn-radio
                >
                ${isDenySelected
                    ? html`<div class="list-wrapper" @click=${this.preventPropagation}>
                          <tmn-select
                              .multiple=${true}
                              @tmn-selections-changed=${this.handleSelectChanged}
                              .data=${availableComps}
                              .name=${'compBlacklist'}
                              .label=${'Deny Competitions'}
                              .selections=${blacklistSelections}></tmn-select
                          ><tmn-button @click="${this.handleClear}" .name=${'compBlacklist'}>
                              <tmn-icon
                                  color="primary"
                                  icon="clear_all"
                                  iconvariant="outlined"
                                  slot="startIcon"></tmn-icon>
                              Clear Deny List
                          </tmn-button>
                      </div>`
                    : null}
            </div>
        </tmn-radio-group> `;
    }

    getSelectedValues() {
        const { value, availableComps = [] } = this;
        const {
            limitType = COMP_LIMIT_TYPE.NONE,
            compWhitelist = [],
            compBlacklist = [],
        } = value ?? {};
        // todo should move these to selectors?
        const whitelistSelections = availableComps.filter((s) => compWhitelist.includes(s.name));
        const blacklistSelections = availableComps.filter((s) => compBlacklist.includes(s.name));
        return {
            limitType,
            whitelistSelections,
            blacklistSelections,
        };
    }

    preventPropagation(e) {
        // stop radio group listening to every click
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
    }

    handleCompOptionChanged(e) {
        this.preventPropagation(e);
        const { path, value } = this;
        const composedEventPath = e.composedPath() || [];
        const target = composedEventPath[0];
        const targetValue = target.value;
        const newValue = {
            ...value,
            limitType: targetValue,
        };
        this.actions.setStagedEditByPath(path, newValue);
    }

    handleClear(e) {
        e.stopPropagation();
        const { path, value } = this;
        const { target } = e;
        // note target.name needs to match the expected properties for COMP_DATA
        const newValue = {
            ...value,
            [target.name]: [],
        };
        this.actions.setStagedEditByPath(path, newValue);
    }

    handleSelectChanged(e) {
        const { path, value } = this;
        const { detail, target } = e;
        const { selections } = detail;
        // note target.name needs to match the expected properties for COMP_DATA
        const newValue = {
            ...value,
            [target.name]: selections.map((s) => s.name),
        };
        this.actions.setStagedEditByPath(path, newValue);
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        return {
            availableComps: selectors.availableLeaguesSelector(state),
        };
    };
};

window.customElements.define(
    'form-element-rugby-competitions',
    connect(mapStateToProps)(FormElementRugbyCompetitions)
);
